import { render } from "./InvoicesOverdue.vue?vue&type=template&id=2f67edad&scoped=true"
import script from "./InvoicesOverdue.vue?vue&type=script&lang=js"
export * from "./InvoicesOverdue.vue?vue&type=script&lang=js"

import "./InvoicesOverdue.vue?vue&type=style&index=0&id=2f67edad&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f67edad"]])

export default __exports__